/** `/c/$companyId/setup` — set up the books; the company layout lets in only who may, while they aren't. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { SetupScreen } from "../ledger/SetupScreen";

export const Route = createFileRoute("/_auth/c/$companyId/setup")({
  component: SetupRoute,
});

function SetupRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <SetupScreen companyId={companyId} />;
}
